<div [formGroup]="form"
     [kalLoading]="loading">

    <h5 class="gup-O-titrage__subTitle">Informations du règlement</h5>

    <ng-container formGroupName="settings" *ngIf="editRepaymentSchedule">

        <div class="activityEditRepayment__infoPayment">

            <div class="gup-C-flexGroup -row -justifyStart -alignCenter">

                <div class="gup-C-flexGroup__item">
                    <strong>Montant à régler</strong> : {{ editRepaymentSchedule.amount | currency: 'EUR' }}
                </div>

                <div class="gup-C-flexGroup__item">
                    <strong>Moyen de paiement</strong> : {{ editRepaymentSchedule.paymentMethod.Libelle }}
                </div>
            </div>

            <ng-container *ngIf="isUpdate">
                <div class="gup-C-flexGroup -row -justifyStart -alignCenter">

                    <div class="gup-C-flexGroup__item">
                        <strong>Bénéficiaire</strong> : {{ editRepaymentSchedule.beneficiary }}
                    </div>

                    <div class="gup-C-flexGroup__item">
                        <strong>Nombre d'échéances</strong>
                        : {{ editRepaymentSchedule.repaymentSchedule.numberOfDueDateCreation }}
                    </div>
                </div>
                <div class="gup-C-flexGroup -row -justifyStart -alignCenter">

                    <div class="gup-C-flexGroup__item">
                        <strong>Restant à payer</strong> : {{ editRepaymentSchedule.remainingAmount | currency: 'EUR' }}
                    </div>

                    <div class="gup-C-flexGroup__item">
                        <strong>Échéances restantes</strong> : {{ editRepaymentSchedule.remainingDueDate }}
                    </div>
                </div>
            </ng-container>

            <kal-form-field>
                <kal-input formControlName="title"
                           id="activity_edit_repayment_schedule_dialog_title"
                           label="Libellé du règlement">
                </kal-input>
            </kal-form-field>

        </div>

        <div class="gup-O-separationLine"></div>

        <ng-container *ngIf="editRepaymentSchedule.invoicesList | arrayNotEmpty">
            <h5 class="gup-O-titrage__subTitle">Factures concernées</h5>
            <kal-table
                [columns]="invoicesListColumns"
                [dataSource]="editRepaymentSchedule.invoicesList"
            >
                <tr *kalHeaderRowDef kal-header-row></tr>
                <td *kalBodyCell="'DateFacture'; let facture">{{facture.DateFacture | date: 'dd/MM/yyyy'}}</td>
                <td *kalBodyCell="'MontantFacture'; let facture">{{facture.MontantFacture | currency}}</td>
            </kal-table>
            <div class="gup-O-separationLine" style="margin-top: 24px"></div>
        </ng-container>


        <!-- début shedule settings -->
        <h5 class="gup-O-titrage__subTitle">Paramétrage des échéances</h5>

        <ng-container formGroupName="schedule">

            <div class="activityEditRepayment__settingDeadlines">

                <!-- dans le cas des prélèvements ou virements , on affiche la sélection de l'iban-->
                <div *ngIf="usingPrevelementOuVirement">
                    <kal-form-field>

                        <app-shared-iban-edit id="accounting_schedule_details_dialog_schedule_iban"
                                              label="Iban"
                                              placeholder="Sélectionner un iban"
                                              formControlName="ibanId"
                                              isRequired="false"
                                              [beneficiaryId]="editRepaymentSchedule.IdBenef">
                        </app-shared-iban-edit>

                    </kal-form-field>
                </div>

                <!-- échéancier : nombre d'échéance + montant échéance -->
                <div class="line1 gup-C-flexGroup -row -justifyStart -alignStartr">

                    <div class="elt1 gup-C-flexGroup__item -tiers">

                        <kal-form-field>

                            <kal-select formControlName="scheduleType"
                                        id="activity_edit_repayment_schedule_dialog_schedule_type"
                                        disableFirstOptionSelection
                                        label="Type d'échéancier">

                                <kal-option [value]="null">Libre</kal-option>

                                <kal-option
                                    *ngFor="let repaymentScheduleModel of repaymentScheduleModelList"
                                    [value]="repaymentScheduleModel">
                                    {{ repaymentScheduleModel.Libelle }}
                                </kal-option>

                            </kal-select>

                        </kal-form-field>

                    </div>

                    <div class="elt2 gup-C-flexGroup__item -tiers">

                        <kal-form-field>

                            <kal-input [errorsMessage]="{ pattern: 'Le champs ne peut contenir que des nombres entiers.',
                                                                  max: 'Le nombre d\'échéance ne peut pas dépasser {max}',
                                                                  min: 'Le nombre d\'échéance doit être de {min} au minimum'}"
                                       formControlName="numberOfDueDate"
                                       id="activity_edit_repayment_schedule_dialog_number_of_due_date"
                                       label="Nombre d'échéances"
                                       type="number">
                            </kal-input>

                        </kal-form-field>

                    </div>

                    <!--
                     dans le cas de la modification, ce champs est perturbant
                     car il ne reflète pas les données du tableau plus bas ( dans le cas où la première échéance est différente des autres )
                     donc en l'enlève ! :)
                     -->
                    <div *ngIf="!isUpdate" class="elt3 gup-C-flexGroup__item -tiers">

                        <kal-form-field>

                            <kal-input [errorsMessage]="
                                                { max: 'Le montant des échéances ne peut pas dépasser {max}€',
                                                  min: 'Le montant des échéances doit être de {min}€ au minimum'}"
                                       formControlName="dueDateAmount"
                                       icon="euro"
                                       id="activity_edit_repayment_schedule_dialog_due_date_amount"
                                       label="Montant des échéances"
                                       type="currency">
                            </kal-input>

                        </kal-form-field>

                    </div>

                </div>

                <!-- échéancier : fréquence et numéro du jour du mois -->
                <div class="line2 gup-C-flexGroup -row -justifyStart -alignCenter">

                    <div class="elt1 gup-C-flexGroup__item">
                        <strong>Prélèvement tous les</strong>
                    </div>

                    <div class="elt2 gup-C-flexGroup__item">
                        <kal-input [style.maxWidth.px]="80"
                                   formControlName="paymentFrequency"
                                   id="activity_edit_repayment_schedule_dialog_payment_frequency"
                                   type="number">
                        </kal-input>
                    </div>

                    <div class="elt3 gup-C-flexGroup__item">
                        <strong>mois, le</strong>
                    </div>

                    <div class="elt4 gup-C-flexGroup__item">

                        <kal-select formControlName="paymentDayOfMonth"
                                    id="activity_edit_repayment_schedule_dialog_payment_day_of_month">
                            <kal-option *ngFor="let v of 1 | array:31"
                                        [value]="v">
                                {{ v }}
                            </kal-option>
                        </kal-select>

                    </div>

                    <div class="elt5 gup-C-flexGroup__item">
                        <strong>de chaque mois.</strong>
                    </div>

                </div>

                <!-- date de payment et première échéance-->
                <kal-form-field class="line3">
                    <kal-datepicker formControlName="paymentStartDate"
                                    id="activity_edit_repayment_schedule_dialog_payment_start_date"
                                    label="A partir du">
                    </kal-datepicker>

                    <!-- Pas possible de mettre la première échéance fixe -->
                    <ng-container *ngIf="!isUpdate">
                        <a (click)="toggleFirstDueAmount()"
                           *ngIf="!hasFirstDueAmount; else firstDueDateAmountTemplate"
                           class="gup-C-moreInfos gup-O-link"
                           id="activity_edit_repayment_schedule_dialog_payment_has_first_due_amount"
                           kalTheme="tertiary">
                            <kal-icon>add</kal-icon>
                            Saisir une première échéance fixe
                        </a>

                        <ng-template #firstDueDateAmountTemplate>
                            <kal-form-field class="gup-C-formFieldSize--bottomNull">
                                <div class="flexLine">
                                    <kal-input formControlName="firstDueDateValue"
                                               class="firstDueDateValue"
                                               label="{{firstDueDateTypeLabel}} de la première échéance"
                                               id="activity_edit_repayment_schedule_dialog_payment_first_due_amount"
                                               type="number">
                                    </kal-input>

                                    <kal-select formControlName="firstDueDateType"
                                                class="firstDueDateType">
                                        <kal-option [value]="FirstDueDateTypeTypes.PERCENTAGE">%</kal-option>
                                        <kal-option [value]="FirstDueDateTypeTypes.EURO">€</kal-option>
                                    </kal-select>
                                </div>
                            </kal-form-field>
                        </ng-template>
                    </ng-container>

                </kal-form-field>

                <kal-button (click)="refreshSchedule()"
                            class="gup-U-margin-bottom--small"
                            kalTheme="tertiary">
                    Regénérer l'échéancier
                </kal-button>
            </div>

            <!-- gestion des chèques uniquement si on est en payement par chèques -->
            <ng-container *ngIf="usingCheque">

                <div class="gup-O-separationLine"></div>

                <!-- début payment settings -->
                <h5 class="gup-O-titrage__subTitle">Chèques</h5>

                <div class="activityEditRepayment__checks">

                    <div class="line1">

                        <kal-form-field>
                            <kal-input formControlName="firstChequeNumber"
                                       id="activity_edit_repayment_schedule_dialog_payment_first_cheque_number"
                                       label="Premier numéro du chèque">
                            </kal-input>
                        </kal-form-field>

                        <kal-form-field class="without-label">

                            <kal-checkbox formControlName="useConsecutiveChequeNumber"
                                          id="activity_edit_repayment_schedule_dialog_payment_use_consecutive_cheque_number"
                                          label="Numéros de chèques consécutifs">
                            </kal-checkbox>

                            <p class="gup-U-color--400 small">
                                Les numéros seront générés de manière consécutive à partir du premier numéro de
                                chèque.
                            </p>
                        </kal-form-field>

                    </div>

                    <div class=" line2 gup-C-flexGroup -row -justifyBetween -alignCenter">

                        <div class="gup-C-flexGroup__item -demi">

                            <kal-form-field>
                                <kal-input (kalAutocompleteSelected)="patchAutocompletedBank($event)"
                                           [kalAutocomplete]="autocompleteBankNameDataSource"
                                           formControlName="bankName"
                                           icon="keyboard_arrow_down"
                                           id="activity_edit_repayment_schedule_dialog_payment_bank_name"
                                           label="Banque">
                                </kal-input>
                            </kal-form-field>

                        </div>

                        <div class="gup-C-flexGroup__item -demi">

                            <kal-form-field>
                                <kal-input formControlName="transactionName"
                                           id="activity_edit_repayment_schedule_dialog_payment_tire_name"
                                           label="Nom tiré">
                                </kal-input>
                            </kal-form-field>

                        </div>

                    </div>

                </div>

            </ng-container>

        </ng-container>
        <!-- fin payment settings -->

    </ng-container>
    <!-- Fin paramétrage de l'échéancier -->

    <ng-container formGroupName="repaymentSchedule">

        <div class="gup-O-separationLine"></div>

        <h5 class="gup-O-titrage__subTitle gup-C-flexGroup__item">Visualisation de l'échéancier</h5>

        <div class="activityEditRepayment__schedule">
            <kal-table #table
                       [actionable]="isUpdate"
                       [columns]="columns"
                       [dataSource]="repaymentSchedule.schedule"
                       [displayedColumns]="displayedColumns"
                       class="no-action"
                       virtualItemSize="30"
                       virtualViewPortHeight="400px">

                <tr *kalHeaderRowDef kal-header-row></tr>
                <tr *kalFooterRowDef kal-footer-row></tr>

                <!-- Action de fin de ligne -->
                <ng-container [kalColumn]="table.actionColumnName">
                    <td *kalBodyCell="let element">
                        <ng-container *ngIf="element.IsRemisEnBanque != true">
                            <kal-button [kalMenuTriggerFor]="actionsMenu"
                                        kalTheme="tertiary">
                                <kal-icon>more_horiz</kal-icon>
                            </kal-button>

                            <kal-menu #actionsMenu>
                                <kal-option (selectionChange)="deleteRepaymentRow(element)">
                                    Supprimer l'échéance
                                </kal-option>
                            </kal-menu>
                        </ng-container>
                    </td>
                    <!--remove footer cell template of Action column-->
                    <ng-template kalFooterCell>
                        <td hidden></td>
                    </ng-template>
                </ng-container>

                <!-- Date remise en banque -->
                <ng-container kalColumn="IsRemisEnBanque">
                    <ng-template kalBodyCell let-element>
                        <td>{{ element.DateRemisEnBnq | date:'dd/MM/yyyy' }}</td>
                    </ng-template>
                    <td *kalFooterCell [attr.colspan]="usingCheque ? 2 : 1" style="text-align: right">
                        Total des échéances
                    </td>
                </ng-container>

                <!--affichage du footer en fonction du mode (création) et du nombre de colonne-->
                <ng-container *ngIf="!isUpdate" kalColumn="NumeroCheque">
                    <td *kalFooterCell colspan="3" style="text-align: right">
                        Total des échéances
                    </td>
                </ng-container>

                <ng-template *ngIf="!isUpdate" kalFooterCell="NomBanque">
                    <td hidden></td>
                </ng-template>

                <!--remove footer cell template of NomTire column-->
                <ng-template kalFooterCell="NomTire">
                    <td hidden></td>
                </ng-template>

                <!-- Date -->
                <ng-container *ngIf="'DateEcheance' as code">
                    <td *kalBodyCell="code let row; let index=index">

                        <kal-datepicker *ngIf="repaymentScheduleForm.at(index)"
                                        [formControl]="repaymentScheduleForm.at(index).get(code)">
                        </kal-datepicker>

                    </td>
                </ng-container>

                <!-- Montant -->
                <ng-container *ngIf="'MontantEcheance' as code">
                    <td *kalBodyCell="code let row let index=index">

                        <kal-input (keydown.arrowDown)="focusNextElement(code, index)"
                                   (keydown.arrowUp)="focusPreviousElement(code, index)"
                                   *ngIf="repaymentScheduleForm.at(index)"
                                   [formControl]="repaymentScheduleForm.at(index).get(code)"
                                   [id]="code + index"
                                   icon="euro"
                                   type="currency"></kal-input>
                    </td>
                    <td *kalFooterCell="code" [attr.colspan]="isUpdate ? '2' : '1'">
                               <span [style.color]="totalOfDueAmounts === editRepaymentSchedule.amount ? 'inherit' : 'red'">
                                    {{ totalOfDueAmounts | currency }}
                                </span>
                        <span>/ {{ editRepaymentSchedule.amount | currency }}</span>
                    </td>
                </ng-container>

                <!-- toutes les autres cases-->
                <td *kalBodyCell="table.defaultColumnName let row let index=index let code = code">
                    <kal-input class="label"
                               (keydown.arrowDown)="focusNextElement(code, index)"
                               (keydown.arrowUp)="focusPreviousElement(code, index)"
                               *ngIf="repaymentScheduleForm.at(index)"
                               [formControl]="repaymentScheduleForm.at(index).get(code)"
                               [id]="code + index"></kal-input>
                </td>

            </kal-table>

            <div *ngIf="isUpdate" class="gup-C-flexGroup -row -justifyBetween">
                <div>
                    <a (click)="addRepaymentRow()"
                       *ngIf="totalOfDueAmounts < editRepaymentSchedule.amount"
                       class="gup-C-moreInfos gup-O-link"
                       id="accounting_bank_deposit_make_bank_deposit">
                        <kal-icon>add</kal-icon>
                        <span>Ajouter une échéance</span>
                    </a>
                </div>

                <div>
                    <kal-button
                        (click)="regenerateLabels()"
                        kalTheme="tertiary">
                        Regénérer le libellé des échéances
                    </kal-button>
                </div>
            </div>

        </div>

    </ng-container>
</div>

